import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosBuzzOne } from '../../../../axios';
import { moduleName } from '../../module';
import {
  getMultiplePartialRolloutRoute,
  getPartialRolloutRoute,
  postPincode,
} from '../../utils/apiRoutes';

export const postPartialRolloutAsync = createAsyncThunk(
  `${moduleName}/postPartialRolloutAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      const { bodyData } = payload;
      const response = await axiosBuzzOne({
        method: 'POST',
        url: getPartialRolloutRoute(),
        data: bodyData,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const postMultiplePartialRolloutAsync = createAsyncThunk(
  `${moduleName}/postMultiplePartialRolloutAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      const { type, path, bodyData } = payload;
      const response = await axiosBuzzOne({
        method: 'POST',
        url: getMultiplePartialRolloutRoute(path),
        data: bodyData,
        params: { type },
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const postPincodesAsync = createAsyncThunk(
  `${moduleName}/postPincodesAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      const { bodyData } = payload;
      const response = await axiosBuzzOne({
        method: 'POST',
        url: postPincode(),
        data: bodyData,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const partialRolloutSlice = createSlice({
  name: `${moduleName}/UserKycApproval`,
  initialState: {
    loading: false,
  },
  reducers: {},
  extraReducers: {
    [postPartialRolloutAsync.pending]: (state) => {
      state.loading = true;
    },
    [postPartialRolloutAsync.fulfilled]: (state) => {
      state.loading = false;
    },
    [postPartialRolloutAsync.rejected]: (state) => {
      state.loading = false;
    },
    [postMultiplePartialRolloutAsync.pending]: (state) => {
      state.loading = true;
    },
    [postMultiplePartialRolloutAsync.fulfilled]: (state) => {
      state.loading = false;
    },
    [postMultiplePartialRolloutAsync.rejected]: (state) => {
      state.loading = false;
    },
    [postPincodesAsync.pending]: (state) => {
      state.loading = true;
    },
    [postPincodesAsync.fulfilled]: (state) => {
      state.loading = false;
    },
    [postPincodesAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

// export const {} = partialRolloutSlice.actions;

export default partialRolloutSlice.reducer;
